// frontend/src/hooks/useMemberValidation.js

import { useMemo } from 'react';
import {
  shouldShowAgeWarning,
  shouldShowInvalidBirthdate
} from '../utils/memberValidationUtils';

// Helper functions (sin cambios)
const trim = v => (v || '').trim();
const tokensFrom = (...parts) =>
  parts
    .filter(Boolean)
    .map(s => String(s).trim())
    .join(' ')
    .split(/\s+/)
    .filter(Boolean);

export const useMemberValidation = (
  editedMember,
  config,
  isFieldsDisabled
) => {
  const isFormValid = useMemo(() => {
    // --- LÓGICA DE VALIDACIÓN REFACTORIZADA ---
    // Esta lógica es "declarativa": solo mira los datos actuales en
    // 'editedMember' para determinar la validez, sin depender de estados
    // de interacción del usuario como 'isNationalIdValid'.

    // 1. Extraer y normalizar datos base
    const nationality = trim(editedMember.nationality);
    const nationalId = trim(editedMember.nationalId);
    const passport = trim(editedMember.passport);
    const gender = trim(editedMember.gender);
    const firstName = trim(editedMember.firstName);
    const lastName = trim(editedMember.lastName);
    
    // El backend envía fechas como 'YYYY-MM-DDTHH:mm:ss.sssZ'.
    // Para la validación, solo necesitamos la parte de la fecha.
    const birthISO = (trim(editedMember.birthdate) || '').split('T')[0];

    // 2. Calcular condiciones fundamentales
    const hasNationality = !!nationality;
    const hasFirstAndLastName = !!firstName && !!lastName;
    const isBirthdateValid = !!birthISO && !shouldShowInvalidBirthdate(birthISO);
    const isOverMaxAge = shouldShowAgeWarning(birthISO);
    const hasMinNameTokens = tokensFrom(
      firstName,
      editedMember.middleName,
      lastName,
      editedMember.secondLastName
    ).length >= 2;

    // 3. Validar el camino de la Cédula/ID Nacional
    let isNationalIdPathOk = false;
    if (nationalId) {
      // Se valida el ID directamente contra las reglas del país.
      const isIdFormatValid = config?.validate
        ? config.validate(nationalId)
        : true; // Si no hay reglas, la presencia es suficiente.

      // El camino de la cédula es válido si cumple todas estas condiciones.
      isNationalIdPathOk =
        hasNationality &&
        isIdFormatValid &&
        hasFirstAndLastName &&
        (isBirthdateValid || isFieldsDisabled) && // Tolera si el padrón bloqueó
        !isOverMaxAge;
    }

    // 4. Validar el camino del Pasaporte (solo si no hay Cédula)
    let isPassportPathOk = false;
    if (!nationalId && passport) {
      // El camino del pasaporte es válido si cumple estas condiciones.
      isPassportPathOk =
        hasNationality &&
        hasMinNameTokens &&
        isBirthdateValid &&
        !!gender &&
        !isOverMaxAge;
    }

    // 5. El formulario es válido si CUALQUIERA de los dos caminos es válido.
    return isNationalIdPathOk || isPassportPathOk;

  }, [editedMember, config, isFieldsDisabled]);

  return { isFormValid };
};